export default __webpack_public_path__ + "static/media/xls.8661d794.svg";